var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"post-thumbnail"},[(_vm.post.thumbnailUrl)?_c('v-card-media',{attrs:{"src":_vm.post.thumbnailUrl,"height":"112"}}):_c('post-default-thumbnail'),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v("\n    "+_vm._s(_vm.post.title)+"\n    "),(_vm.updated)?_c('inline-badge'):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12ebf1d0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PostThumbnail.vue
// module id = 476
// module chunks = 1